<template>
  <router-link :to="to">
    <div class="img">
      <!-- 이미지 미리보기 -->
      <img v-if="item.previewContentType !== 'VIDEO'" :src="item.previewContentUrl" :alt="item.title" loading="lazy"/>
      <!-- 비디오 미리보기 (YouTube) -->
      <iframe v-else
              :src="getYoutubeEmbedUrl(item.previewContentUrl)"
              class="video-preview"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
      </iframe>
      <!-- Type chip (항상 표시) -->
      <div class="type-badge-wrap">
        <div :class="['type-badge', `badge-${item.articleSpecialType?.toLowerCase()}`]">
          {{ formatArticleType(item.articleSpecialType) }}
        </div>
      </div>
    </div>
    <div class="txt-box">
      <h3 class="title">
        <span class="text">{{ item.title }}</span>
        <HeartButton v-model:isLike="localIsLike"  :uuid="item.uuid" :likeType="item.likeType" /> 
      </h3>
      <p>{{ item.subTitle }}</p>
    </div>
  </router-link>
</template>

<script setup>
import {computed, defineEmits, defineProps, ref} from 'vue';
import HeartButton from "@/components/ui/HeartButton.vue";

const props = defineProps({
  isLike: Boolean,
  item: Object,
  to: Object,
});
const isLike = ref(props.isLike);

const emit = defineEmits(["update:isLike"]);

const localIsLike = computed({
  get: () => isLike.value,
  set: (newValue) => {
    isLike.value = newValue;
    emit("update:isLike", newValue);
  }
});


// articleSpecialType 첫글자만 대문자로 변환 (INTERVIEW → Interview)
const formatArticleType = (type) => {
  if (!type) return '';
  return type.charAt(0) + type.slice(1).toLowerCase();
};

// YouTube URL을 embed 형식으로 변환
const getYoutubeEmbedUrl = (url) => {
  if (!url) return '';
  // YouTube URL 패턴: https://www.youtube.com/watch?v=xxxxx or https://youtu.be/xxxxx
  const videoId = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/)?.[1];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
};

</script>

<style scoped>
/* Type chip (우측 상단, 항상 표시) */
.type-badge-wrap {
  position: absolute;
  top: 10px;
  right: 9px;
}

.type-badge {
  width: 92px;
  height: 36px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;

  box-shadow: 0px 0px 20px rgba(21, 20, 25, 0.6);
  border-radius: 5px;

  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}

/* Type별 배지 스타일 */
.type-badge.badge-column {
  background-color: #0900FF;
  color: #FFFFFF;
  box-shadow: 0px 0px 20px rgba(21, 20, 25, 0.6);
}

.type-badge.badge-interview {
  background-color: #FFD353;
  color: #151419;
  box-shadow: 0px 0px 20px rgba(21, 20, 25, 0.6);
}

.type-badge.badge-video {
  background-color: #FF0042;
  color: #FFFFFF;
  box-shadow: 0px 0px 20px rgba(21, 20, 25, 0.6);
}

.img {
  position: relative;
}

.img img {
  aspect-ratio: 647 / 394.6;
  /*object-fit: cover;*/
}

.img .video-preview {
  width: 100%;
  aspect-ratio: 647 / 394.6;
  border-radius: 0;
}

.txt-box {
  display: flex;
  flex-direction: column;
}

.title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 5px;
}

.title span {
  font-size: clamp(14px, 3.5vw, 20px);
  font-weight: bold;
  flex-grow: 1;
  flex-basis: 0;
  text-align: left;
  letter-spacing: -0.6px;
  color: #fff;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.article .list-type3>ul li button.btn-heart {
  position: static;
  bottom: auto;
  right: auto;
}

@media (max-width: 768px) {
  .type-badge-wrap {
    top: 8px;
    right: 8px;
  }
}
</style>